/**
 * 给模型字典的每个 value 注入其 key 作为 `id`。
 *
 * 展示名已迁移到数据库（model_access.labels），代码内不再维护硬编码 label。
 * 注入 id 后，展示层可在数据库未配置 label 时回退到模型 id（见 use-model-label）。
 */
export function withModelIds<T extends object>(
  models: Record<string, T>,
): Record<string, T & { id: string }> {
  const out: Record<string, T & { id: string }> = {};
  for (const [id, model] of Object.entries(models)) {
    out[id] = { ...model, id };
  }
  return out;
}
